export enum AdsChunkSize {
  Small = 4,
  Compact = 8,
  Middle = 24,
}
